<div class="w-100 flex-row flex-wrap justify-start items-stretch">
  <div class="header w-100 flex-row space-between items-center">
    <span class="text-muted"><strong>moovs in process</strong></span>
    <button mat-button color="accent" (click)="onUpdateClick()"><mat-icon class="text-muted">update</mat-icon></button>
  </div>
  @if (busy) {
    <app-mat-spinner-overlay  [overlay]="true"></app-mat-spinner-overlay>
  }
  @let ds = dataSource;
  @if(ds){
    <table mat-table [fixedLayout] [dataSource]="ds ?? []" matSort matSortActive="added" matSortDirection="desc" class="w-100">
      @if (isSuperAdmin) {
        <ng-container matColumnDef="customer">
          <th mat-header-cell *matHeaderCellDef>Customer</th>
          <td mat-cell *matCellDef="let mia" class="wrap-cell">{{(getCustomer(mia.customerId) | async)?.name}}</td>
        </ng-container>
      }

      <ng-container matColumnDef="sourceFileName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Source File</th>
        <td mat-cell *matCellDef="let mia" class="break-word-cell" matTooltip="{{mia.sourceFileName}}" > {{mia.sourceFileName}} </td>
      </ng-container>

      <ng-container matColumnDef="moovDefinitionName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> moov </th>
        <td mat-cell *matCellDef="let mia" class="wrap-cell"> {{mia.moovDefinitionName}} </td>
      </ng-container>

      <ng-container matColumnDef="added">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date Received </th>
        <td mat-cell *matCellDef="let mia" class="wrap-cell"> {{mia.added | date:"MM/dd/yyyy hh:mm:ss a"}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let mia; columns: displayedColumns;" (click)="selectionChanged(mia)"></tr>
    </table>
  }
  <mat-divider class="w-100"></mat-divider>
  <div class="w-100 flex-row justify-end items-center">
    @if (ds?.data?.length === 0) {
      <p class="py-5 mb-0 text-center">No data available</p>
    }
    <div [hidden]="ds?.data?.length === 0">
      <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 50, 100]" showFirstLastButtons (page)="pageChanged($event)"></mat-paginator>
    </div>
  </div>